import React, {cloneElement} from 'react';
import {Text, TouchableOpacity} from 'react-native';
import {BUTTON_TYPES} from '../../../utils/Constants';
import {tID} from '../../../utils/TestIdHelper';
import {useTheme, useThemedStyles} from '../../../theme';
import makeStyles from './styles';
import CommonStyles from '../../../utils/CommonStyles';

const ButtonWithIcon = ({
  style = {},
  titleStyle = {},
  buttonType = BUTTON_TYPES.Bordered,
  onPress,
  title,
  titleColor,
  topMargin = 0,
  disabled,
  disabledColor,
  icon,
  iconTintColor,
  testID = tID('ButtonWithIcon-Text-Title'),
}) => {
  // Themed DEFAULTS only (mainLargeText → link, grey3 → textDisabled,
  // black → textPrimary; identical in light). Explicit props still win.
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const resolvedTitleColor =
    titleColor === undefined ? colors.link : titleColor;
  const resolvedDisabledColor =
    disabledColor === undefined ? colors.textDisabled : disabledColor;
  const resolvedIconTintColor =
    iconTintColor === undefined ? colors.textPrimary : iconTintColor;

  let buttonStyle = [styles.borderedButton, style];

  if (buttonType === BUTTON_TYPES.Plain) {
    buttonStyle = [style];
  } else if (buttonType == BUTTON_TYPES.Filled) {
    buttonStyle = [styles.filledButton, style];
  }

  if (disabled && buttonType === BUTTON_TYPES.Filled) {
    buttonStyle = [buttonStyle, {backgroundColor: resolvedDisabledColor}];
  } else if (disabled && buttonType === BUTTON_TYPES.Bordered) {
    buttonStyle = [buttonStyle, styles.op07];
  }

  return (
    <TouchableOpacity
      testID={tID('ButtonWithIcon-TouchableOpacity-Main')}
      disabled={disabled}
      style={[{marginTop: topMargin}, styles.buttonContainer, buttonStyle]}
      onPress={onPress}
    >
      {cloneElement(icon, {
        testID: tID('ButtonWithIcon-Image-Icon'),
        tintColor: resolvedIconTintColor,
        width: 18,
        height: 18,
        style: CommonStyles.mr_12,
      })}
      <Text
        testID={testID}
        adjustsFontSizeToFit={true}
        minimumFontScale={0.8}
        style={[
          styles.titleStyle,
          {color: resolvedTitleColor, flexShrink: 1},
          titleStyle,
        ]}
      >
        {title}
      </Text>
    </TouchableOpacity>
  );
};

export default ButtonWithIcon;
